module.exports = __webpack_public_path__ + "img/resource-1.739c3c80.png";